<template>
  <div id="contenedor-municipios-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'MunicipiosMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
